import { OpenRegular } from '@fluentui/react-icons';
import styled, { css } from 'styled-components';
import {
  CheckmarkCircleRegular,
  MoreCircleRegular,
  DismissCircleRegular,
  PauseCircleRegular,
  PersonClockRegular,
  ErrorCircleRegular,
  ArrowSyncCircleRegular,
} from '@fluentui/react-icons';

export const Container = styled.div`
  padding: 16px;
  border-radius: 4px;
  background: ${(props) => props.theme.serviceDeskMainBackground};
  box-shadow: 0px 0.15px 0.45px 0px rgba(0, 0, 0, 0.11),
    0px 0.8px 1.8px 0px rgba(0, 0, 0, 0.13);
`;

export const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: max-content max-content 1fr max-content max-content;
  grid-template-rows: max-content 8px max-content 16px max-content;
  grid-template-areas:
    'id id . date date'
    '. . . . .'
    'description description description description  description'
    '. . . . .'
    'status status . . openTicketDetail';
`;

export const Id = styled.div`
  grid-area: id;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${(props) => props.theme.serviceDeskTextColorSecondary};
`;

export const Date = styled.div`
  grid-area: date;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${(props) => props.theme.serviceDeskTextColorSecondary};
`;

export const Description = styled.p`
  grid-area: description;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: ${(props) => props.theme.serviceDeskTextColorPrimary};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const Status = styled.div`
  grid-area: status;
`;

export const OpenTicketDetailIcon = styled(OpenRegular)`
  grid-area: openTicketDetail;
  width: 24px;
  height: 24px;
  cursor: pointer;
  padding: 0px 2px;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.calendarDividerColor};
  background: ${(props) => props.theme.mainBackgorund};
`;

const iconCommonStyles = css`
  width: 16px;
  height: 16px;
`;

export const ResolvedIcon = styled(CheckmarkCircleRegular)`
  ${iconCommonStyles};
`;

export const WaitingFor3rdPartyIcon = styled(PersonClockRegular)`
  ${iconCommonStyles};
`;

export const InvalidIcon = styled(ErrorCircleRegular)`
  ${iconCommonStyles};
`;

export const OnHoldIcon = styled(PauseCircleRegular)`
  ${iconCommonStyles};
`;

export const CancelledIcon = styled(DismissCircleRegular)`
  ${iconCommonStyles};
`;

export const OpenIcon = styled(MoreCircleRegular)`
  ${iconCommonStyles};
`;

export const InProgressIcon = styled(ArrowSyncCircleRegular)`
  ${iconCommonStyles};
`;
